
export const removeSymbolsRegex = /[^a-zA-ZабвгдѓежзѕијклљмнњопрстќуфхцчџшАБВГДЃЕЖЗЅИЈКЛЉМНЊОПРСТЌУФХЦЧЏШ]/g;
export const cyrillicUpperCharacters = ['А', 'Б', 'В', 'Г', 'Д', 'Ѓ', 'Е', 'Ж', 'З', 'Ѕ', 'И', 'Ј', 'К', 'Л', 'Љ', 'М', 'Н', 'Њ', 'О', 'П', 'Р', 'С', 'Т', 'Ќ', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Џ', 'Ш'];
export const cyrillicLowerCharacters = ['а', 'б', 'в', 'г', 'д', 'ѓ', 'е', 'ж', 'з', 'ѕ', 'и', 'ј', 'к', 'л', 'љ', 'м', 'н', 'њ', 'о', 'п', 'р', 'с', 'т', 'ќ', 'у', 'ф', 'х', 'ц', 'ч', 'џ', 'ш'];
export const cyrillicAllCharacters = [
    ...cyrillicUpperCharacters,
    ...cyrillicLowerCharacters,
];

export default function (value) {
    if (!value || !value.length) {
        return false;
    }

    const charWithoutSymbols = value.replace(removeSymbolsRegex, '');

    if (!charWithoutSymbols.length) {
        return false;
    }

    const charValues = charWithoutSymbols.trim().split('');

    const onlyCyrillicValueCharacters = charValues.filter(char => cyrillicAllCharacters.includes(char));

    return onlyCyrillicValueCharacters.length === charWithoutSymbols.length;
}